window.ReportUpdater = function(){
    var me;
    return {
        progressReports: null,
        counter: 0,
        delayMultiple: 1,
        updatePath: null,
        init: function(progressReports, updatePath) {
            me = this;
            me.progressReports = progressReports;
            me.updatePath = updatePath;
        },
        checkUpdateIn: function(delay) {
            if (me.counter > 2000) return false;
            if (me.counter > 100) me.delayMultiple = 10;
            setTimeout(me.checkUpdate, delay * me.delayMultiple);
        },
        pushReport: function(report){
            me.progressReports.push(report);
        },
        checkUpdate: function(){
            if (me.progressReports.length == 0) return false;
            me.counter++;
            $.ajax(me.updatePath, { type: 'GET', data: { reports: me.progressReports }});
        },
        success: function(list_of_finished_reports){
            me.progressReports = me.progressReports.filter( function( el ) {
                return !list_of_finished_reports.includes( el );
            });
        }
    }
}();
